import { GridRow } from '@tkww/orion-web-ds';
import { TextTitle } from '@tkww/orion-web-ds-text';
import { FAQ } from '@typings/faq';
import React, { useEffect, useState, FC } from 'react';
import { connect } from 'react-redux';
import QaPair from './qaPair';
import Styles from './styles.scss';

interface Caret {
	isOpen: boolean;
	name: string;
}

interface DynamicFAQProps {
	data: FAQ[];
	isMobile: boolean;
}

const DynamicFAQ: FC<DynamicFAQProps> = (props) => {
	const { data, isMobile } = props;
	const [caret, setCaret] = useState<Caret[]>([]);

	useEffect(() => {
		if (data?.length && data.length !== caret.length) {
			const iterateData = data.map(() => ({
				name: 'caret_down',
				isOpen: false,
			}));
			setCaret(iterateData);
		}
	}, [data?.length]);

	if (!data || data.length === 0) {
		return null;
	}
	return (
		<GridRow>
			<div className={Styles.wrapper}>
				<div className={isMobile ? Styles.faqBodyMobile : Styles.faqBody}>
					<TextTitle size="xs" className={Styles.title}>
						Frequently Asked Questions
					</TextTitle>
					<div className={Styles.dataUnit}>
						{data.map((item, idx) => (
							<QaPair
								key={item.question}
								caret={caret}
								idx={idx}
								isMobile={isMobile}
								item={item}
								setCaret={setCaret}
								data-testid="qa-pair"
							/>
						))}
					</div>
				</div>
			</div>
		</GridRow>
	);
};

const mapStateToProps = (state: Redux.State) => ({
	data: state.faq.data,
	isMobile: state.viewport.isMobile,
});

export default connect(mapStateToProps)(DynamicFAQ);
